var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{},[(_vm.items.length)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('headerPdf',{attrs:{"title":"مهارت فردی"}})],1),_c('b-col',{attrs:{"cols":"12"}},_vm._l((_vm.items),function(item,i){return _c('ul',{key:i},[_c('li',[_vm._v(" "+_vm._s(item.skill_caption)+" ")])])}),0)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }